function smgFaqSetOpen(item, wrap, open) {
  if (open) {
    item.setAttribute('open', '');
    wrap.style.maxHeight = wrap.scrollHeight + 'px';
  } else {
    wrap.style.maxHeight = '0px';
    item.removeAttribute('open');
  }
}

function initSmgFaq(scope) {
  var items = Array.prototype.slice.call((scope || document).querySelectorAll('[data-smg-faq-item]'));

  items.forEach(function (item) {
    if (item.dataset.smgFaqBound) return;
    item.dataset.smgFaqBound = 'true';

    var summary = item.querySelector('summary');
    var wrap = item.querySelector('.smg-faq__answer-wrap');
    if (!summary || !wrap) return;

    if (item.hasAttribute('open')) {
      wrap.style.maxHeight = wrap.scrollHeight + 'px';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      var opening = !item.hasAttribute('open');

      items.forEach(function (other) {
        if (other === item) return;
        var otherWrap = other.querySelector('.smg-faq__answer-wrap');
        if (otherWrap && other.hasAttribute('open')) smgFaqSetOpen(other, otherWrap, false);
      });

      smgFaqSetOpen(item, wrap, opening);
    });

    window.addEventListener('resize', function () {
      if (item.hasAttribute('open')) wrap.style.maxHeight = wrap.scrollHeight + 'px';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initSmgFaq(document);
  });
} else {
  initSmgFaq(document);
}

document.addEventListener('shopify:section:load', function (e) {
  initSmgFaq(e.target);
});
